import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Storage } from 'src/app/models/storage';
import { StorageService } from 'src/app/services/storage.service';
import { MatDialog } from '@angular/material';
import { EdgeDialogComponent } from '../dialogs/edge-dialog/edge-dialog.component';
import _ from 'lodash';
import { AccordionService } from 'src/app/services/accordion.service';

@Component({
  selector: '[app-standard-edge]',
  templateUrl: './standard-edge.component.html',
})
export class StandardEdgeComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  storage: Storage;
  width: 0;
  length: 0;
  depth: 0;
  @Input() edgeKey: number;
  @Input() windowKey: number;
  @Input() side: string;
  isSameDepth = false;

  constructor(
    private storageService: StorageService,
    public dialog: MatDialog,
    private accordionService: AccordionService,
  ) { }

  ngOnInit() {
    this.storage = this.storageService.storage;
    this.storageSubscription();
    this.canvasEventSubscription();
  }

  private canvasEventSubscription() {
    this.accordionService.canvasEvent = null;
    this.subscription = this.accordionService.canvasEvent$.subscribe((data) => {
      const key: number = data;
      if (key === this.edgeKey) {
        this.handleAddEdgeDialog('STANDARD', key);
      }
    });
  }

  private storageSubscription() {
    this.subscription = this.storageService.storage$.subscribe(async (data) => {
      this.storage = data;

      if (this.storage.windows[this.windowKey] === undefined ) {
        return false;
      }
      this.width = this.storage.windows[this.windowKey].standard[this.getSideName(this.side)].edges[this.edgeKey].width;
      this.length = this.storage.windows[this.windowKey].standard[this.getSideName(this.side)].edges[this.edgeKey].length;
      this.isSameDepth = this.storage.windows[this.windowKey].standard[this.getSideName(this.side)].isSameDepth;
      this.depth = this.isSameDepth ?
        this.storage.windows[this.windowKey].standard[this.getSideName(this.side)].depth :
        this.storage.windows[this.windowKey].standard[this.getSideName(this.side)].edges[this.edgeKey].depth;
    });
  }

  handleAddEdgeDialog(type: string, index: number) {
    const data = {
      width: this.width,
      length: this.length,
      depth: this.isSameDepth ? undefined : this.depth,
    };

    const dialogRef = this.dialog.open(EdgeDialogComponent, {
      width: '640px',
      panelClass: 'selena-calculator',
      data: {
        type,
        index,
        data,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.status === 'OK') {
        const storage = this.storage;
        storage.windows[this.windowKey].standard[this.getSideName(this.side)].edges[this.edgeKey].width = result.data.width;
        storage.windows[this.windowKey].standard[this.getSideName(this.side)].edges[this.edgeKey].length = result.data.length;

        if (!this.isSameDepth) {
          storage.windows[this.windowKey].standard[this.getSideName(this.side)].edges[this.edgeKey].depth = result.data.depth;
        }

        this.storageService.storage = storage;
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getSideName(staticName: string) {
    switch (staticName) {
      case 'INSIDE':
        return 'inside';
      case 'OUTSIDE':
        return 'outside';
    }
  }

}
